export default "__VITE_ASSET__DdYJ0Ra1__"